// extracted by mini-css-extract-plugin
export default {"content":"DuplicatesRemoveLimitWarningModal__content--DXFEt","imageWrapper":"DuplicatesRemoveLimitWarningModal__imageWrapper--1W_aL"};